export default {
  className: '',
  description: null,
  disabled: false,
  id: null,
  label: null,
  labelLocation: 'before',
  onChange: null,
  required: false,
  tooltip: null
}
